module.exports = __webpack_public_path__ + "static/media/refresh-icon.6e4d8c2f.svg";